"use strict";

var Paypal = require('./paypal/paypal'); 
var ApplePay = require('app_adyen_SFRA/adyen/express/paymentMethods/applepay/applepay');
var GooglePay = require('app_adyen_SFRA/adyen/express/paymentMethods/googlepay/googlepay');
var AmazonPay = require('app_adyen_SFRA/adyen/express/paymentMethods/amazonpay/amazonPayExpressPart1');
var expressPaymentMethods = {
  Paypal: Paypal,
  ApplePay: ApplePay,
  GooglePay: GooglePay,
  AmazonPay: AmazonPay
};
module.exports = expressPaymentMethods;